<i18n>
{
  "en": {
    "label": {
      "userComment": "Please write here if there is a supplementary comment"
    },
    "message": {
      "uploading": "Now uploading...",
      "donePost": "Thank you very much. The upload is complete. Please wait for confirmation",
      "errorPost": "Could not send correctly. Please try later or contact us if the error occurs repeatedly.",
      "hires": "Please submit <b>\"High Resolution Image Data\" (JPEG or TIFF data with the highest quality) without credit</b> for the winning candidate.",
      "hiresOption": "※Please submit an image that has been cropped in the same way as the work posted on SNS.",
      "original": "Please submit <b>\"RAW data\" of the winning candidate work or “original data before processing (the highest quality of JPEG data or TIFF data, with EXIF information left).</b>",
      "warning": "Once uploaded, files can not be deleted. Please do not make a mistake",
      "originalOption": "It is for the purpose of identity verification to prevent plagiarism. Thank you for your cooperation."
    }
  },
  "ja": {
    "label": {
      "userComment": "補足コメントがあればこちらにお書き下さい"
    },
    "message": {
      "uploading": "アップロード中…",
      "donePost": "ありがとうございます。アップロードが完了しました。確認をお待ち下さい",
      "errorPost": "正しく送信できませんでした。時間を置いてお試しいただくか、繰り返しエラーが発生する場合はお問い合わせをお願いいたします。",
      "hires": "<b>受賞候補作品のクレジットなしの「高解像度画像データ」（JPEGもしくはTIFFデータで最高画質のもの）</b>をご提出下さい。",
      "hiresOption": "※SNS投稿作品が受賞候補となっている場合は、投稿時と同じようにトリミングしていただいた画像のご提出をお願いします。",
      "original": "<b>受賞候補作品の「RAWデータ」もしくは「Exif（撮影日時や撮影機種）が保存されている、加工前のオリジナルデータ（カメラで撮ったままの、何のソフトウェアも使用していない画像データ）」</b>をご提出下さい。",
      "warning": "一度アップロードしたファイルは削除できません。お間違いのないよう、お願い致します",
      "originalOption": "盗作防止のためにご本人様確認を行う目的でお願いしております。恐れ入りますがご協力をお願い申し上げます。"
    }
  }
}
</i18n>

<template>
  <div class="upload-form-wrapper">
    <v-container style="padding-top: 4px;">
      <v-layout wrap style="display: flex; flex-direction: column; justify-content: center; align-items: center;">
        <v-flex
          xs12
          sm12
          md12
          lg12
          xl12
          v-if="submissionType === EnumSubmissionType.HiRes"
          style="width: 100%; max-width: 640px; text-align: left;"
        >
          <span style="color: red" class="subheading" v-html="$t('message.hires')"></span>
          <a :href="'/cp/' + getCampaignCode() + '/me/help#category3'" target="_blank" style="text-decoration: none;"><v-icon class="ml-1 hover-icon" slot="activator" dark color="primary">help_outline</v-icon></a>
          <br />
          <br />
          <p class="red--text">{{ $t('message.hiresOption') }}</p>
        </v-flex>
        <v-flex
          xs12
          sm12
          md12
          lg12
          xl12
          v-if="submissionType === EnumSubmissionType.Original"
          style="width: 100%; max-width: 640px; text-align: left;"
        >
          <span style="color: red" class="subheading" v-html="$t('message.original')"></span>
          <a :href="'/cp/' + getCampaignCode() + '/me/help#category2'" target="_blank" style="text-decoration: none;"><v-icon class="ml-1 hover-icon" slot="activator" dark color="primary">help_outline</v-icon></a>
          <br />
          <br />
          <!--<p>{{ $t('message.originalOption') }}</p>-->
        </v-flex>
        <v-flex style="width: 100%; max-width: 640px;">
          <FileDrop
            :uploadFunc="postData"
            :subOption="fileTypeOptions"
            :mustAnsToSubOption="true"
            :submissionType="submissionType"
          ></FileDrop>
        </v-flex>
      </v-layout>
    </v-container>

    <LoadingDialog
      :isLoading="isLoading"
      :loadingMessage="this.$t('message.uploading')"
    />
  </div>
</template>

<script>
import FileDrop from '@/components/atoms/FileDrop.vue';
import TextInput from '@/components/atoms/TextInput.vue';
import LoadingDialog from '@/components/dialogs/LoadingDialog.vue';
import { Me } from '@/api';
import subOptionHandler from '@/helper/subOptionHandler.js';
import { EnumSubmissionType } from '@/enum/enum.js';
import StorageManager from '@/utils/StorageManager';

export default {
  components: {
    FileDrop,
    TextInput,
    LoadingDialog
  },
  props: {
    workId: Number,
    submissionType: Number
  },
  data() {
    return {
      EnumSubmissionType: EnumSubmissionType,
      isLoading: false
    };
  },
  methods: {
    reload() {
      this.$router.go();
    },
    postData(files, userComment) {
      return new Promise((resolve, reject) => {
        this.isLoading = true;

        this.uploadFiles(files)
          .then(files => {
            return Me.postSubmissions(this.workId, {
              userComment: userComment,
              submissionType: this.submissionType,
              submissionFiles: files
            });
          })
          .then(() => {
            alert(this.$t('message.donePost'));
            this.reload();
            return resolve();
          })
          .catch(error => {
            alert(this.$t('message.errorPost'));
            return reject(error);
          })
          .finally(() => {
            this.isLoading = false;
          });
      })
    },
    async uploadFiles(files) {
      let fileList = [];
      for (const file of files) {
        await Me.uploadFile(file.dataAsForm).then(uuid => {
          fileList.push({
            submissionFileType: file.subOptionAnswer.code,
            tmpFileUuid: uuid
          });
        });
      }
      return fileList;
    },
    getCampaignCode: () => {
      return StorageManager.getItem('CAMPAIGN_CODE_SESSION_KEY');
    }
  },
  computed: {
    fileTypeOptions() {
      let list = this.$store.getters.getEnumsObjByType('submissionFileType');
      return subOptionHandler(list, this.submissionType);
    }
  }
};
</script>

<style lang="stylus" scoped>
.upload-form-wrapper
    background-color: white;
    padding: 10px;
    padding-top: 0px;
    width: 100%;
    min-height: 300px;
    height: 50%;
    text-align: center;
</style>
